module.exports = __webpack_public_path__ + "static/media/chain-store-1.cd930bf8.png";